import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/appointments'),
    name: 'wasapi_appointments',
    component: () => import('./pages/AppointmentsPage.vue'),
    meta: { permissions: ['administrator', 'agent'] },
  },
];
